import { Immutable } from "immer";
import React from "react";

import { concatClassNames } from "@thelabnyc/thelabui/src/utils/styles";

import heroStyles from "./index.module.scss";

type Props = Immutable<{
    imageUrl: string | null;
    imageAlt: string;
    mobileImageUrl: string | null;
}>;

export const HeroPicture = (props: Props): React.JSX.Element => {
    return (
        <div
            className={concatClassNames([
                heroStyles.root,
                "legacy-product-hero",
            ])}
        >
            <picture className="pdp-hero__image">
                {props.mobileImageUrl && (
                    <source
                        srcSet={props.mobileImageUrl}
                        media="(max-width: 768px)"
                    />
                )}
                {props.imageUrl && (
                    <img
                        src={props.imageUrl}
                        alt={props.imageAlt}
                        fetchPriority="high"
                    />
                )}
            </picture>
        </div>
    );
};
